import { EVENTS } from '../constants/webSocketConsts/events';
import {
  insertFormsNotifications,
  updateNotifications,
  deleteNotifications,
} from '../store/notifications/actions';
import { NotificationGroups } from '../store/notifications/types';

const formCompletedNotificationHandler = (event: string, items: Array<any>) => {
  switch (event) {
    case EVENTS.INSERT:
      return insertFormsNotifications(
        items,
        NotificationGroups.FormCompleteNotifications,
      );
    case EVENTS.MODIFY:
      return updateNotifications(
        items,
        NotificationGroups.FormCompleteNotifications,
      );
    case EVENTS.REMOVE:
      return deleteNotifications(
        items,
        NotificationGroups.FormCompleteNotifications,
      );
    default:
      break;
  }
  return null;
};

export default formCompletedNotificationHandler;
